export default "__VITE_ASSET__BCidSKpA__"